<template>
    <div class="saas-feature section-space--ptb_90 bg-gray">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center section-space--mb_60">
                        <h2 class="font-weight--light mb-15 wow move-up">Built for Higher Engineering Output</h2>
                        <span class="section-text wow move-up">Create the most happy and productive version of your engineering team</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
                    <div class="service-grid">
                        <div class="ht-service-box--one style-03">
                            <router-link :to="'branding'">
                                <div class="image__media">
                                    <img :src="item.icon" class="img-fluid" alt="aeroland-app-showcase-box-icon-image-01">
                                </div>
                                <div class="content">
                                    <h6 class="heading">{{ item.heading }}</h6>
                                    <div class="service_text">{{ item.text }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SassFeature',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/visibility_purple.png'), 
                        heading: 'End-2-End Visibility', 
                        text: 'Eliminate the guesswork, get granular visibility to manage your teams. See work patterns, check engineering health and identify operational inefficiencies in a single glance'
                    },
                    {
                        icon: require('../assets/img/icons/productivity_purple.png'), 
                        heading: 'Enhanced Productivity', 
                        text: 'Productivity is either going up or down. Make data-driven decisions and objectively see a positive or negative effect on your engineering throughput without interrupting your team'
                    },
                    {
                        icon: require('../assets/img/icons/collaborate_purple.png'), 
                        heading: 'Data-driven Collaboration', 
                        text: 'Automated PR reminders, risk alerts and a single view day-to-day worklog. Objective metrics improve communication between technical and non-technical teams'
                    },

                ]
            }
        }
    }
</script>
